<template>
 
  <router-view :key="$route.fullPath" />
    <BackToTop /> <!-- 全局统一 -->
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { ElConfigProvider } from "element-plus";
import { Options, Vue } from 'vue-class-component';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
 
import Layheard from '@/components/lay-heard/index.vue';
@Options({
  components: {
   Layheard
  },
})

export default class HomeView extends Vue {}
</script>


<style lang="scss">
 

 
</style>
